<template>
	<div class="accessibility-controls">
		<template v-if="step === 1">
			<div class="abs-center text-center" v-if="treatmentsession">

				<template v-if="$config.getValue('generatefeedbacktoken')">
					<h1>
						<span class="badge badge-secondary">{{ $t('feedback-token-colon') }} {{ treatmentsession.feedbacktoken }}</span>
					</h1>
					<button class="btn btn-primary mb-8" @click="skip">{{ $t('done') }}</button>
				</template>

				<hr v-if="$config.getValue('generatefeedbacktoken') && $config.getValue('requestpatientfeedback')" class="mb-8" />

				<template v-if="$config.getValue('requestpatientfeedback')">
					<h2>{{ $t('ready-for-patient-feedback') }}</h2>
					<p>{{ $t('please-hand-device-to-patient') }}</p>
					<button class="btn btn-primary" @click="nextStep">{{ $t('patient-click-here') }}</button>
				</template>

			</div>
			<div class="text-center" style="position: absolute; bottom: 25px; top: auto; left: 0; right: 0;">
				<button class="btn btn-link" @click="skip">{{ $t('skip-this-step') }}</button>
			</div>
		</template>
		<template v-else-if="step === 2">
            <div class="row">
                <AccesibilityControls
                    class="ml-auto mr-3" 
                    :stepSize="2"
                />
            </div>
			<ul v-if="questions.length" class="list-unstyled">
				<li v-for="question in questions" :key="question.id">
					<FeedbackQuestion
						:question="question"
						:ref="`question-${question.id}`"
					></FeedbackQuestion>
				</li>
			</ul>
			<button class="btn btn-primary" :disabled="saving" @click="save">{{ $t('save-feedback') }}</button>
		</template>
		<template v-else>
			<div class="abs-center text-center">
				<h2>{{ $t('thank-you-for-your-feedback') }}</h2>
				<p>{{ $t('please-hand-device-to-student') }}</p>
				<button class="btn btn-primary" @click="done" v-if="showStudentLoginBtn">
					{{ $t('student-login') }}
				</button>
			</div>
		</template>
	</div>
</template>
<script>
import FeedbackQuestion from "src/components/FeedbackQuestion.vue";
import AccesibilityControls from "src/components/AccesibilityControls.vue";
//import "@/styles/custom.scss"

export default {
	props: {},
	components: {
		FeedbackQuestion,
        AccesibilityControls
	},
	data() {
		return {
			step: 1,
			questions: [],
			showStudentLoginBtn: false,
			treatmentsession: null,
			saving: false,
            fontSize: 12
		};
	},
	mounted() {
		this.getQuestions();
		this.getTreatmentSession();
		// hide menu
		this.$store.state.showMenu = false;
	},
	computed: {},
	methods: {
		done() {
			this.$store.state.showMenu = true;
			this.$router.replace(`/clinical`);
		},
		nextStep() {
			if (this.step < 3) {
				this.step++;
			}
			if (this.step === 3) {
				setTimeout(() => {
					this.showStudentLoginBtn = true;
				}, 5000);
			}
		},
		skip() {
			this.$store.state.showMenu = true;
			this.$router.replace(`/clinical`);
		},
		save() {
			// a second tap while saving would submit the feedback twice
			if (this.saving) {
				return;
			}
			const data = {
				treatmentSessionId: this.$route.params.treatmentsessionid,
				feedbackData: []
			};

			// get values
			let value;
			for (let question of this.questions) {
				value = this.$refs[`question-${question.id}`][0].getValue();
				if (question.type == "1") {
					data.feedbackData.push({ questionId: question.id, responseId: value });
				} else if (question.type == "2") {
					// yuck - api expects different data structure for comments!
					data.feedbackData.push({ questionId: question.id, comment: value });
				}
			}

			this.saving = true;
			this.$store.commit("showBlockingSpinner");
			this.$cfetch(`${this.$settings.APIBaseURL}/treatmentsessions/patientfeedback/save`, {
				method: "post",
				data: {
					data: data
				}
			})
				.then(this.$assertApiSuccess)
				.then(() => {
					this.$store.commit("hideBlockingSpinner");
					this.nextStep();
				})
				.catch(err => {
					this.$store.commit("hideBlockingSpinner");
					this.saving = false;
					// an earlier attempt got through (e.g. its response was lost), so the feedback is stored
					if (this.$apiErrorType(err) === "FEEDBACK_ALREADY_SUBMITTED") {
						this.nextStep();
						return;
					}
					this.$showApiError(err, { fallback: "feedback-save-failed" });
				});
		},
		getQuestions() {
			this.$cfetch(`${this.$settings.APIBaseURL}/treatmentsessions/patientfeedback/listquestions`, {
				method: "post",
				data: {
					id: this.$route.params.treatmentsessionid
				}
			})
				.then(json => {
					if (json.status === "SUCCESS") {
						this.questions = json.questions;
					} else {
						this.$log.error.call(this, "Could not get questions for treatment session");
						this.done();
					}
				})
				.catch(error => {
					this.$log.error.call(this, error);
				});
		},
		getTreatmentSession() {
			this.$store.commit("showBlockingSpinner");
			this.$cfetch(`${this.$settings.APIBaseURL}/treatmentsessions/load`, {
				method: "post",
				data: {
					id: this.$route.params.treatmentsessionid
				}
			})
			.then(json => {
				this.$store.commit("hideBlockingSpinner");
				if (json.status === "SUCCESS") {
					this.treatmentsession = json.treatmentsession;
				} else {
					this.unableToOpenTreatmentSession();
					this.$log.error.call(this, "Could not fetch treatment session");
				}
			})
			.catch(error => {
				this.$store.commit("hideBlockingSpinner");
				this.unableToOpenTreatmentSession();
				this.$log.error.call(this, error);
			});
		},
		unableToOpenTreatmentSession() {
			const self = this;
			this.$store.commit("openDialog", {
				title: this.$t("oops"),
				content: this.$t("unable-to-open-treatment-session"),
				confirmCallBack: function() {
					self.$router.replace("/clinical");
				}
			});
		}
	}
};
</script>

